import { HttpClient, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { API_ENDPOINTS } from "../constants/api-endpoints";
import { ApiService } from "./api.service";
import { FloorInfo } from "../models/floorinfo.model";
import { FloorInfoDTO, SyncFloorItem } from "../models/request/floorinfo/floorinfo.dto.model";
import { FloorInfoRO } from "../models/response/floorinfo/floorinfo.ro.model";

@Injectable({ providedIn: 'root' })
export class FloorInfoService extends ApiService {

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  async getFloorByMap(mapid: string): Promise<FloorInfo[] | null> {
    let pra: FloorInfoDTO = {
      mid: mapid
    };
    let apiUrl = API_ENDPOINTS.FLOOR_INFO.CONTROLLER + API_ENDPOINTS.FLOOR_INFO.LIST_FLOOR_BY_MAP;
    let resData = await lastValueFrom(this.post<FloorInfoRO, FloorInfoDTO>(apiUrl, pra));
    if (resData && resData.status === HttpStatusCode.Ok && resData.result && resData.result.listfloorinfos)
      return resData.result.listfloorinfos;
    return null;
  }

  async addFloor(floorInfo: FloorInfo): Promise<boolean> {
    let apiUrl = API_ENDPOINTS.FLOOR_INFO.CONTROLLER + API_ENDPOINTS.FLOOR_INFO.ADD_FLOOR;
    let resData = await lastValueFrom(this.post<FloorInfoRO, FloorInfo>(apiUrl, floorInfo));
    if (resData && resData.status === HttpStatusCode.Ok && resData.result && resData.result.success)
      return true;
    return false;
  }

  async syncFloors(mapid: string, floors: SyncFloorItem[]): Promise<number> {
    let pra: FloorInfoDTO = {
      mid: mapid,
      floors: floors
    };
    let apiUrl = API_ENDPOINTS.FLOOR_INFO.CONTROLLER + API_ENDPOINTS.FLOOR_INFO.SYNC_FLOORS;
    let resData = await lastValueFrom(this.post<FloorInfoRO, FloorInfoDTO>(apiUrl, pra));
    if (resData && resData.status === HttpStatusCode.Ok && resData.result && resData.result.success)
      return resData.result.rowsaffected ?? 0;
    return 0;
  }
}
